import React from 'react';

export function SuccessIcon (color) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" fill={ color } fillRule="evenodd"/>
    </svg>
  );
}
